import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Home } from './components/home/Home';

const AuthenticatedRoute = () => {
  const { isSignedIn } = useSelector((state) => state.authorization);
  return isSignedIn ? <Home /> : <Navigate to={'/signin'} />;
};

export default AuthenticatedRoute;
